<svg xmlns="http://www.w3.org/2000/svg"
     width="32"
     height="32"
     fill="currentColor"
     viewBox="0 0 256 256">
  <path
        d="M184 32H72a16 16 0 00-16 16v176a8 8 0 0012.24 6.78L128 193.43l59.77 37.35A8 8 0 00200 224V48a16 16 0 00-16-16z" />
</svg>